import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FastCodesPage } from './fast-codes';

@NgModule({
  declarations: [
    FastCodesPage,
  ],
  imports: [
    IonicPageModule.forChild(FastCodesPage),
  ],
})
export class FastCodesPageModule {}



// WEBPACK FOOTER //
// ./src/app/sports/fast-codes/fast-codes.module.ts